import http from "./http";

// LOGIN
export const loginUser = async (mobile, password) => {
  const res = await http.post("login", {
    mobile,
    password,
  });

  /*
    API RESPONSE:
    {
      status: true,
      token: "...",
      user: { id, name, role },
      permissions: [ "dashboard.view", ... ]
    }
  */

  if (res.data?.status === true) {
    localStorage.setItem("token", res.data.token);
    localStorage.setItem("user", JSON.stringify(res.data.user));
    localStorage.setItem(
      "permissions",
      JSON.stringify(res.data.permissions || [])
    );
  }

  return res.data;
};

// LOGOUT
export const logout = () => {
  localStorage.clear();
  window.location.href = "/sign-in";
};
